import styles from './UpdatePasswordModal.module.scss';
import { Form as FormComponent, Input, Modal as ModalComponent, notification } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { changeUpdatePasswordModalVisibility } from '../../redux/actions/global';
import UserService from '../../services/UserService';

const UpdatePasswordModal = () => {
    const dispatch = useDispatch();

    const visible = useSelector(state => state.global.isUpdatePasswordModalVisible);

    const validatePassword = value => {
        if (value.length < 6 || value.length > 20) {
            return Promise.reject('Password must be between 6 and 20 characters');
        } else if (!/[a-z]/.test(value)) {
            return Promise.reject('Password must contain at least one lowercase letter');
        } else if (!/[A-Z]/.test(value)) {
            return Promise.reject('Password must contain at least one uppercase letter');
        } else if (!/\d/.test(value)) {
            return Promise.reject('Password must contain at least one number');
        } else if (!/[^a-zA-Z0-9]/.test(value)) {
            return Promise.reject('Password must contain at least one special character');
        } else {
            return Promise.resolve();
        }
    };

    const onCancel = () => {
        dispatch(changeUpdatePasswordModalVisibility(false));
    };

    const onFormFinish = async values => {
        const { info } = await UserService.changePassword(values);

        notification.destroy();

        if (!info.success) {
            notification.error({ message: info.errors[0].reason || info.errors[0].message });
            return;
        }

        notification.success({ message: 'Successfully updated' });
        dispatch(changeUpdatePasswordModalVisibility(false));
    };

    return (
        <ModalComponent
            className={styles.modal}
            centered
            title='Change password'
            visible={visible}
            onCancel={onCancel}
            okText={'Update'}
            okButtonProps={{
                form: 'update-password-form',
                htmlType: 'submit',
            }}
            destroyOnClose
            maskClosable={false}
        >
            <FormComponent id={'update-password-form'} className={styles.form} onFinish={onFormFinish}>
                <FormComponent.Item
                    name={'currentPassword'}
                    label='Current password'
                    className={styles.formItem}
                    rules={[{ required: true, message: 'Current Password is required' }]}
                >
                    <Input.Password placeholder='Password' />
                </FormComponent.Item>

                <FormComponent.Item
                    name={'newPassword'}
                    label='New password'
                    className={styles.formItem}
                    rules={[
                        { required: true, message: 'New Password is required' },
                        {
                            validator: (_, value) => validatePassword(value),
                        },
                    ]}
                >
                    <Input.Password placeholder='Password' />
                </FormComponent.Item>
                <FormComponent.Item
                    name={'confirm'}
                    dependencies={['newPassword']}
                    label='Confirm password'
                    className={styles.formItem}
                    hasFeedback
                    rules={[
                        {
                            required: true,
                            message: 'Please confirm your password!',
                        },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('newPassword') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('The two passwords that you entered do not match!'));
                            },
                        }),
                    ]}
                >
                    <Input.Password placeholder='Confirm new password' />
                </FormComponent.Item>
            </FormComponent>
        </ModalComponent>
    );
};

export default UpdatePasswordModal;
